exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-link[data-v-b300164e]{position:relative;display:block}.email-link.with-before[data-v-b300164e]:before{content:\"copied\";position:absolute;top:0;left:0;width:101%;background:#fff;text-align:left;display:block}.mt-3-5[data-v-b300164e]{margin-top:0!important}", ""]);

// exports
